import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import includes from 'lodash/includes';
import { injectIntl, intlShape } from 'react-intl';
import messages from './messages';
import Upload from '../../components/quick-upload/index';
import { downloadQuickUploadTemplate, quickUpload, closeModal, quickUploadFailure } from './actions';
import { Warning, Tick } from '../../helpers/icon-dictionary';
import Modal from '../../components/modal/index';
import UploadSummary from '../../components/upload-summary/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import css from './index.scss';

class QuickUpload extends Component {
    static propTypes = {
        componentType: PropTypes.string,
        downloadingQuickUploadTemplate: PropTypes.bool,
        uploadingTemplate: PropTypes.bool,
        showModal: PropTypes.bool,
        message: PropTypes.object,
        uploadSummary: PropTypes.object,
        downloadQuickUploadTemplate: PropTypes.func,
        quickUpload: PropTypes.func,
        quickUploadFailure: PropTypes.func,
        closeModal: PropTypes.func,
        selectedProduct: PropTypes.object,
        intl: intlShape.isRequired
    };

    static contextTypes = {
        router: PropTypes.object
    }

    handleDownloadQuickUploadTemplate = () => {
        this.props.downloadQuickUploadTemplate(true);
    }

    handleQuickUpload = (file) => {
        const { intl } = this.props;
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
            const fileContent = e.target.result.split(',')[1];
            this.props.quickUpload(this.props.selectedProduct.id, fileContent, true);
        };

        fileReader.onError = () => {
            this.props.quickUploadFailure(true, '', true, false);
        };

        if (this.validateFileType(file.type)) {
            fileReader.readAsDataURL(file);
        } else {
            this.props.quickUploadFailure(false,
                intl.formatMessage(messages.fileFormatValidationMessage), true, false, true);
        }
    }

    validateFileType = (fileType) => {
        const allowedFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        return includes(allowedFileTypes, fileType);
    }

    closeModal = () => {
        this.props.closeModal(false);
    }

    handleOnSuccess = () => {
        this.props.closeModal(false);
        this.context.router.history.push('students');
    }

    generateErrorRow = (errors, intl) => {
        let errorMessages = [];
        errorMessages = errors.map(error => (<div className={css.rowNumber} key={uniqueId('uploadValidationMessages')}>
            { error.rowReference !== '-1' ? (`${intl.formatMessage(messages.row)} ${error.rowReference}`) : '' }
            <div className={css.message}>{error.message}</div>
        </div>));

        return errorMessages;
    }

    GenerateResultRow = (intl, uploadSummary) => (<div
        className={css.resultContainer}
        key={uniqueId('quickUploadResult')}>
        <div className={css.resultSection}>
            <div> {uploadSummary.newStudents.length} {intl.formatMessage(messages.newStudentCM)}</div>
            <div> {uploadSummary.updatedStudents.length} {intl.formatMessage(messages.updatedStudentCM)}</div>
            <div> {uploadSummary.unassignedStudents.length} {intl.formatMessage(messages.unassignedStudentCM)}</div>
        </div>
        <div className={css.resultSection}>
            <div> {uploadSummary.newTeachers.length} {intl.formatMessage(messages.newTeacherCM)}</div>
            <div> {uploadSummary.updatedTeachers.length} {intl.formatMessage(messages.updatedTeacherCM)}</div>
        </div>
        <div className={css.resultSection}>
            <div> {uploadSummary.newClassrooms.length} {intl.formatMessage(messages.newClassesCM)}</div>
            <div> {uploadSummary.updatedClassrooms.length} {intl.formatMessage(messages.updatedClassesCM)}</div>
        </div>
    </div>);

    loadModalComponent = (componentType) => {
        if (componentType) {
            const { intl, message, uploadSummary } = this.props;
            const messageTitle = message.header !== '' ? intl.formatMessage(message.header) : '';
            const messageBody = message.body;

            let component = '';

            switch (componentType) {
            case 'validation':
                component = (
                    <UploadSummary
                        handleOnCloseModal={this.closeModal}
                        icon={Warning}
                        message={messageTitle}
                        quickUploadErrorPage> {this.generateErrorRow(messageBody, intl)}
                    </UploadSummary>);
                break;
            case 'confirmation':
                component = (<ConfirmationMessage
                    handleOnCloseModal={this.handleOnSuccess}
                    icon={Tick}
                    title={messageTitle}>
                    {this.GenerateResultRow(intl, uploadSummary)}
                </ConfirmationMessage>);
                break;
            case 'warning':
                component = (<ConfirmationMessage
                    handleOnCloseModal={this.closeModal}
                    icon={Warning}
                    message={messageBody}
                    title={messageTitle}>
                    <div>{messageBody}</div>
                </ConfirmationMessage>);
                break;
            default:
                break;
            }

            return component;
        }
        return '';
    }

    render() {
        const { showModal, componentType } = this.props;
        return (
            <div>
                <Upload
                    downloadingQuickUploadTemplate={this.props.downloadingQuickUploadTemplate}
                    handleOnDownloadTemplate={this.handleDownloadQuickUploadTemplate}
                    handleOnUploadClick={this.handleQuickUpload}
                    isUploading={this.props.uploadingTemplate}
                    productName={this.props.selectedProduct.name}
                />
                <Modal show={showModal}>
                    {this.loadModalComponent(componentType)}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
    downloadingQuickUploadTemplate: state.quickUpload.downloadingQuickUploadTemplate,
    uploadingTemplate: state.quickUpload.uploadingTemplate,
    showModal: state.quickUpload.showModal,
    message: state.quickUpload.message,
    componentType: state.quickUpload.componentType,
    selectedProduct: state.product,
    uploadSummary: state.quickUpload.uploadSummary
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        downloadQuickUploadTemplate,
        quickUpload,
        quickUploadFailure,
        closeModal
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(QuickUpload));



// WEBPACK FOOTER //
// ./app/containers/quick-upload/index.js